module.exports = __webpack_public_path__ + "static/img/realme.b7f93188.png";